import React, { useState, useEffect } from "react";
import "./EditarPerfilUser.css";
import { useNavigate } from "react-router-dom";

const API = process.env.REACT_APP_API_URL;

const EditarPerfilUser = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = localStorage.getItem("token");
    let navigate = useNavigate()


    const renovarToken = async () => {
    console.log("Intentando renovar sesión...");
    try {
      const res = await fetch(API + "/user/refresh", {
        method: "POST",
        credentials: "include" 
      });
      if (res.ok) {
        const data = await res.json();
        localStorage.setItem("token", data.accessToken);
        console.log("Token renovado con éxito");
        return true;
      }
    } catch (error) {
      console.error("Error crítico al renovar token:", error);
    }
    return false;
  };

    const [formData, setFormData] = useState({
        nombre: user?.nombre || "",
        username: user?.username || "",
        email: user?.email || "",
        telefono: user?.telefono || "",
        direccion: user?.direccion || "",
    });

    const [mensaje, setMensaje] = useState({ texto: "", tipo: "" });

    const traerDatos = async () => {
        if (!user?.id || !token) return;
        try {
            const response = await fetch(`${API}/user/traerUserId/${user.id}`, {
                headers: { "Authorization": `Bearer ${token}` }
            });
            if (!response.ok) throw new Error("Error al obtener perfil");

            if (response.status === 403) {
        const renovado = await renovarToken();
        if (renovado) return await traerDatos(); 
        return;
      }
            const data = await response.json();
            if (data?.datos) {
                setFormData({
                    nombre: data.datos.nombre || "",
                    username: data.datos.username || "",
                    email: data.datos.email || "",
                    numeroCelular: data.datos.numeroCelular || "",
                    direccion: data.datos.direccion || "",
                });
            }
        } catch (error) {
            console.error("Error al obtener perfil:", error);
        }
    };

    useEffect(() => {
        traerDatos();
    }, []);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMensaje({ texto: "Guardando cambios...", tipo: "" });
        try {
            const response = await fetch(`${API}/user/ActualizarUser/${user.id}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify(formData)
            });

            if (response.status === 403) {
        const renovado = await renovarToken();
        if (renovado) return await handleSubmit(); 
        return;
      }

            if (response.ok) {
                const data = await response.json();
                setMensaje({ texto: "¡Perfil actualizado con éxito!", tipo: "success" });
                alert("¡Perfil actualizado con éxito!")
                navigate("/PerfilUser")
                
            } else {
                setMensaje({ texto: "Error al actualizar los datos", tipo: "error" });
            }
        } catch (error) {
            setMensaje({ texto: "Error de conexión", tipo: "error" });
        }
    };

    return (
        <div className="config-container">
            <div className="config-card">
                <h2>Mi Perfil</h2>
                <p className="subtitle">Actualiza tus datos para tus próximos pedidos</p>

                {mensaje.texto && (
                    <div className={`alerta ${mensaje.tipo}`}>{mensaje.texto}</div>
                )}

                <form onSubmit={handleSubmit} className="config-form">
                    <div className="form-group">
                        <label>Nombre Completo</label>
                        <input type="text" name="nombre" value={formData.nombre} onChange={handleChange} required />
                    </div>

                    <div className="form-group">
                        <label>Nombre de Usuario</label>
                        <input type="text" value={formData.username} disabled className="input-disabled" />
                    </div>

                    <div className="form-group">
                        <label>Correo Electrónico</label>
                        <input type="email" value={formData.email} disabled className="input-disabled" />
                    </div>

                    <div className="form-group">
                        <label>Teléfono de contacto</label>
                        <input 
                            type="tel" 
                            name="numeroCelular" 
                            value={formData.numeroCelular} 
                            onChange={handleChange} 
                            placeholder="Ej: 3001234567"
                            required 
                        />
                    </div>

                    <div className="form-group">
                        <label>Dirección de Envío</label>
                        <textarea 
                            name="direccion" 
                            value={formData.direccion} 
                            onChange={handleChange} 
                            placeholder="Calle, Carrera, Apto, Conjunto..."
                            rows="3" 
                            required
                        ></textarea>
                    </div>

                    <button type="submit" className="btn-guardar">
                        Guardar Información
                    </button>
                </form>
            </div>
        </div>
    );
};

export default EditarPerfilUser;